import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { RefrigerationCircuitMessagesStore } from '@store';

@Component({
  selector: 'app-refrigerant-circuit-history-modal',
  templateUrl: './refrigerant-circuit-history-modal.component.html',
  styleUrls: ['./refrigerant-circuit-history-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefrigerantCircuitHistoryModalComponent implements OnInit {
  constructor(
    public refrigerationCircuitMessagesStore: RefrigerationCircuitMessagesStore,
    public dialogRef: MatDialogRef<RefrigerantCircuitHistoryModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      boilerSerial: string;
    }
  ) {}

  ngOnInit(): void {
    this.refrigerationCircuitMessagesStore.getRefrigerationCircuitMessages();
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
